import { apiBasic, apiGet } from "./requests";

export const getDiscounts = () => {
  let path = "discounts/";
  return apiGet(path);
};

export const newDiscount = (data) => {
  let path = "discounts";
  return apiBasic(data, path);
};

export const updateDiscount = (data, discountId) => {
  let path = "discount/" + discountId;
  return apiBasic(data, path, "patch");
};

export const deleteDiscount = (discountId) => {
  console.log("did", discountId);
  let path = "discount/" + discountId;
  return apiBasic(discountId, path, "delete");
};

export const deleteBatchDiscounts = (discountIds) => {
  console.log("dids", discountIds);
  let path = "discount/delete-batch";
  return apiBasic({ discountIds }, path, "delete");
};

export const addCategoryToDiscount = (data, discountId) => {
  let path = "discount/" + discountId + "/add-categories";
  return apiBasic(data, path, "post");
};

export const toogleDiscounts = (discountId) => {
  let path = "discount/" + discountId + "/toogle-active-status";
  return apiGet(path);
};
